import type { PageLoad } from './$types';

export const load: PageLoad = ({ params }) => {
  return {
    meta: {
      title: 'New Class',
      activeNav: 'classes',
      breadcrumbs: {
        activeTitle: 'New',
        items: [
          {
            title: 'Classes',
            href: '/admin/classes',
          },
        ],
      },
    },
  };
};
